import { useState } from 'react';

import { useQuestionsContext } from '../context';

export function useQuestionModal() {
  const { createQuestion, updateQuestion, loading } = useQuestionsContext();

  const [showModal, setShowModal] = useState(false);
  const [editingQuestion, setEditingQuestion] = useState(null);

  function openCreateModal() {
    setEditingQuestion(null);
    setShowModal(true);
  }

  function openEditModal(question) {
    setEditingQuestion(question);
    setShowModal(true);
  }

  function closeModal() {
    setShowModal(false);
    setEditingQuestion(null);
  }

  async function saveQuestion(questionData) {
    if (editingQuestion) {
      await updateQuestion(editingQuestion.id, questionData);
    } else {
      await createQuestion(questionData);
    }
    closeModal();
  }

  return {
    showModal,
    editingQuestion,
    isEditing: editingQuestion !== null,
    loading,
    openCreateModal,
    openEditModal,
    closeModal,
    saveQuestion,
  };
}
